module.exports = __webpack_public_path__ + "static/media/Industriekessel_01.00fc0bee.jpg";